import { gql } from '@apollo/client';

export const DELETE_HEALTH_CHECKUP_INSTITUTION = gql`
  mutation deleteHealthCheckupInstitution($input: DeleteHealthCheckupInstitutionInput!) {
    deleteHealthCheckupInstitution(input: $input) {
      id
    }
  }
`;

export interface DeleteHealthCheckupInstitutionQueryVariables {
  input: {
    id: number;
  };
}

export interface HealthCheckupInstitution {
  id: string;
  healthCheckupInstitutionId: string;
  name: string;
  location: string;
}
